<template>
  <div v-if="content" class="page experience">
    <div class="content">
      <div class="inner-content">
        <left-bar class="left-bar" />

        <div class="bottom-bar">
          <div class="bottom-content">
            <div class="bottom-top-container">
              <div class="entity-container">
                <popup
                  :left="popup.left"
                  :top="popup.top"
                  :show="popup.show"
                  :type="popup.type"
                  :logos="popup.logos"
                  :primary-color="popup.primaryColor"
                  :service-name="popup.service.name"
                  :service-link-description="popup.service.linkDescription"
                  :colaborator-service="popup.colaborator.service"
                  :colaborator-name="popup.colaborator.name"
                  :colaborator-position="popup.colaborator.position"
                  :colaborator-picture="popup.colaborator.picture"
                />
                <canvas ref="experienceCanvas" class="experienceCanvas">
                </canvas>
              </div>
            </div>
            <bottom-bar class="bottom-child" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.experience {
  // Todo
  color: white;
  position: relative;
  background: url("../assets/fake-background.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #000;

  .content {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 4rem;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .inner-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      .left-bar,
      .bottom-bar {
        background-color: transparent;
      }
      .left-bar {
        height: 100%;
        width: 25%;
      }

      .bottom-bar {
        align-self: flex-end;
        height: 100%;
        width: 75%;
        // background-color: blue;
        .bottom-content {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding-top: 2rem;
          .bottom-top-container {
            flex: 1;
            width: 100%;
            .entity-container {
              height: 100%;
              width: 100%;
              // background-color: red;
              position: relative;
              .entity {
                position: absolute;
                width: 12vh;
                height: 12vh;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  width: 70%;
                }
              }
              canvas.experienceCanvas {
                width: 100%;
                height: 100%;
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }
}
// UI animation when swithing from landing view to experience view
.ui-enter-active {
  transition-delay: 0.6s;
  transition: opacity 0.6s;
}
.ui-enter {
  opacity: 0;
}
</style>
<script>
import leftBar from "../components/left-bar/index.vue";
import bottomBar from "../components/bottom-bar/index.vue";
import { mapState, mapMutations, install } from "vuex";
import * as Babylon from "babylonjs";
import { options3D, flags, entitiesNames, atomes } from "../js/constants.js";
import Popup from "../components/popup.vue";

import { sphereShader } from "../js/shaders.js";

const FRAME_RATE = 60;
export default {
  components: {
    leftBar,
    bottomBar,
    Popup,
  },
  data() {
    return {
      entities: [],
      experienceScene: null,
      experienceEngine: null,
      // entities meshs
      spheres: [],
      //services meshs
      spheresServices: [],
      tubeServices: [],
      showService: false,
      //atome mesh
      atome: null,

      // animation variables
      entityOk: flags.animation.landingEntity,
      servicesTubesOk: false,

      // mesh mouvements
      entityMouvement: flags.mouvement.entity,

      //popup handler
      popup: {
        left: null,
        top: null,
        show: false,
        // popup type
        /**
         *   entity
         *   service-name
         *   service-link
         *   colaborator
         */
        type: null,
        // data
        logos: {}, // getting all the logos
        primaryColor: null,
        service: {
          name: null,
          linkDescription: null,
        },
        colaborator: {
          service: null,
          name: null,
          position: null,
          picture: null,
        },
      },

      // zoom time out for animation purpose
      zoomTimeOut: undefined,
      postProcessInterval: undefined,
    };
  },
  computed: {
    ...mapState(["content", "currentZoom", "selectedEntity"]),
  },
  watch: {
    currentZoom() {
      if (typeof this.zoomTimeOut !== undefined) clearTimeout(this.zoomTimeOut);
      if (flags["3d"]) {
        this.zoomTimeOut = setTimeout(() => {
          this.zoomHandler();
          this.blurScene(this.experienceScene);
        }, 300);
      }
    },
  },
  mounted() {
    // babylonjs setup for experience 3d
    this.entities = this.content.entities;

    if (flags["3d"]) {
      this.experienceEngine = new Babylon.Engine(
        this.$refs.experienceCanvas,
        true
      );
      this.experienceScene = this.createScene();

      this.experienceEngine.runRenderLoop(() => {
        this.experienceScene.render();

        // entity mouvement animation
        if (this.entityMouvement) this.animateEntity();
      });

      // creating 3d objetcs
      this.loadSpheres();
      this.loadServices();

      this.zoomHandler(); // ! need to be deleted or refator the use
    }
  },
  methods: {
    ...mapMutations(["setSelectedEntity", "setSelectedService"]),
    // zoom function for 3d
    createScene() {
      let scene = new Babylon.Scene(this.experienceEngine);
      scene.clearColor = new Babylon.Color4(0, 0, 0, 0);
      let camera;
      if (!flags.rotateCamera) {
        camera = new Babylon.FreeCamera(
          "experienceCamera",
          new Babylon.Vector3(
            options3D.x5.experienceCamera.x,
            options3D.x5.experienceCamera.y,
            options3D.x5.experienceCamera._z
          ),
          scene
        );
      } else {
        camera = new Babylon.ArcRotateCamera(
          "Camera",
          options3D.x5.experienceFreeCamera.x,
          options3D.x5.experienceFreeCamera.y,
          options3D.x5.experienceFreeCamera.z,
          Babylon.Vector3.Zero(),
          scene
        );
        camera.lowerRadiusLimit = options3D.x5.experienceFreeCamera.z / 2;
        camera.upperRadiusLimit = options3D.x5.experienceFreeCamera.z;
        camera.attachControl(this.$refs.experienceCanvas, true);
      }

      const light = new Babylon.HemisphericLight(
        "light",
        new Babylon.Vector3(1, 1, 0),
        scene
      );
      camera.setTarget(Babylon.Vector3.Zero());

      this.blurScene(scene);

      return scene;
    },
    zoomHandler() {
      this.resetPopup();
      switch (this.currentZoom) {
        case 5:
          setTimeout(() => {
            this.entityOk = true;
          }, 600);
          for (const entity of this.spheres) {
            entity.isPickable = true;
            materialCheker(entity, entity.metadata.colors.secondary, true);
          }
          this.disposeAtome();
          this.disposeTubes();
          this.setSelectedService({ entity: null, service: null });
          this.staticEntity(0);
          this.staticServices(10000, false);
          break;
        case 10:
          this.disposeAtome();
          this.staticServices(0);
          this.staticEntity(0);
          this.loadSpheres();
          for (const entity of this.spheres) {
            entity.isPickable = false;
            if (
              entity.metadata.ref !== this.entities[this.selectedEntity].ref &&
              entity.metadata.ref !== "gta-supports"
            ) {
              materialCheker(entity, entity.metadata.colors.secondary);
            }
          }

          for (const service of this.spheresServices) {
            if (
              service.metadata.entityData.ref ===
              this.entities[this.selectedEntity].ref
            ) {
              materialCheker(
                service,
                service.metadata.entityData.colors.secondary,
                true
              );
              continue;
            }
            if (service.metadata.entityData.ref === "gta-supports") {
              materialCheker(
                service,
                service.metadata.entityData.colors.secondary,
                true
              );
              continue;
            }

            materialCheker(
              service,
              service.metadata.entityData.colors.secondary
            );
          }
          break;
        case 100:
          this.setSelectedService({ entity: null, service: null });
          this.disposeTubes();
          this.disposeEntities();
          this.loadAtome();
          this.staticCollaborators(0);
          this.staticServices(10000, false);
          break;
        default:
      }
    },
    entityClick(id) {
      this.setSelectedEntity(id);
    },

    // 3D methods
    loadSpheres() {
      if (this.spheres.length > 0) return;
      //create the sphere with the right colors
      let i = 0;
      for (const entity of this.entities) {
        const name = entity.ref;
        // sphere mesh creation
        let sphereMesh = Babylon.Mesh.CreateSphere(
          name,
          options3D.x5.sphere.segments,
          options3D.x5.sphere.diameter,
          this.experienceScene
        );
        sphereMesh.id = i;
        const position = {
          x: entity.position.x,
          y: entity.position.y,
          z: 0,
        };
        //sphere posistion
        sphereMesh.position = new Babylon.Vector3(
          position.x,
          position.y,
          position.z
        );

        // setup material
        // parse rgba color
        let sphereColor = getColorArray(entity.colors.secondary) || {
          r: 229 / 255,
          g: 61 / 255,
          b: 61 / 255,
          a: 0.6,
        };

        //entity shader
        sphereMesh.material = sphereShader(sphereColor);
        sphereMesh.computeWorldMatrix(true);

        // sphere action manager
        sphereMesh.actionManager = new Babylon.ActionManager(
          this.experienceScene
        );
        sphereMesh.actionManager.registerAction(
          new Babylon.ExecuteCodeAction(
            Babylon.ActionManager.OnPickTrigger,
            this.sphereClickAction
          )
        );
        sphereMesh.actionManager.registerAction(
          new Babylon.ExecuteCodeAction(
            Babylon.ActionManager.OnPointerOverTrigger,
            this.sphereHoverAction
          )
        );
        sphereMesh.actionManager.registerAction(
          new Babylon.ExecuteCodeAction(
            Babylon.ActionManager.OnPointerOutTrigger,
            this.sphereHoverOutAction
          )
        );
        sphereMesh.metadata = entity;

        if (entity.ref !== "gta-supports") {
          const animation = new Babylon.Animation(
            "sphereSlide",
            "position",
            FRAME_RATE,
            Babylon.Animation.ANIMATIONTYPE_VECTOR3,
            Babylon.Animation.ANIMATIONLOOPMODE_CYCLE
          );
          const keyFrames = [
            {
              frame: 0,
              value: new Babylon.Vector3(position.x, position.y, position.z),
            },
            {
              frame: FRAME_RATE * 3,
              value: new Babylon.Vector3(
                position.x + randomisePoistion(0.4, 0),
                position.y + randomisePoistion(0.4, 0),
                position.z
              ),
            },
            {
              frame: FRAME_RATE * 8,
              value: new Babylon.Vector3(
                position.x + randomisePoistion(0.4, 0),
                position.y + randomisePoistion(0.4, 0),
                position.z
              ),
            },
            {
              frame: FRAME_RATE * 10,
              value: new Babylon.Vector3(
                position.x + randomisePoistion(0.4, 0),
                position.y + randomisePoistion(0.4, 0),
                position.z
              ),
            },
            {
              frame: FRAME_RATE * 15,
              value: new Babylon.Vector3(
                position.x + randomisePoistion(0.4, 0),
                position.y + randomisePoistion(0.4, 0),
                position.z
              ),
            },
            {
              frame: FRAME_RATE * 201,
              value: new Babylon.Vector3(position.x, position.y, position.z),
            },
          ];
          animation.setKeys(keyFrames);
          sphereMesh.animations.push(animation);
          this.experienceScene.beginAnimation(
            sphereMesh,
            0,
            20 * FRAME_RATE,
            true
          );
        }

        this.spheres.push(sphereMesh);
        i++; // i is used as id of entity
      }
    },
    loadServices() {
      for (const entity of this.entities) {
        let i = 0;
        if (entity.ref === "gta-supports") {
          for (const service of entity.services[0].list) {
            i++;
            const serviceSphere = new Babylon.Mesh.CreateSphere(
              `${entity.ref}-${service.name}`,
              options3D.x10.sphere.segments,
              options3D.x10.sphere.diameter,
              this.experienceScene
            );
            const position = {
              x:
                options3D.x10.sphere._r * Math.cos((Math.PI / 6) * i) +
                entity.position.x,
              y:
                options3D.x10.sphere._r * Math.sin((Math.PI / 6) * i) +
                entity.position.y,
              z: options3D.x10.sphere._z,
            };
            serviceSphere.position = new Babylon.Vector3(
              position.x,
              position.y,
              position.z
            );
            this.spheresServices.push(serviceSphere);

            //sphere material

            // parse rgba color
            let sphereColor = getColorArray(entity.colors.secondary) || {
              r: 229 / 255,
              g: 61 / 255,
              b: 61 / 255,
              a: 0.6,
            };

            serviceSphere.material = sphereShader(sphereColor);

            serviceSphere.computeWorldMatrix(true);

            // sphere action manager
            serviceSphere.actionManager = new Babylon.ActionManager(
              this.experienceScene
            );
            serviceSphere.actionManager.registerAction(
              new Babylon.ExecuteCodeAction(
                Babylon.ActionManager.OnPickTrigger,
                this.servicesClickAction
              )
            );
            serviceSphere.actionManager.registerAction(
              new Babylon.ExecuteCodeAction(
                Babylon.ActionManager.OnPointerOverTrigger,
                this.servicesHoverAction
              )
            );
            serviceSphere.actionManager.registerAction(
              new Babylon.ExecuteCodeAction(
                Babylon.ActionManager.OnPointerOutTrigger,
                this.servicesHoverOutAction
              )
            );

            // service metadata
            serviceSphere.metadata = {
              entityData: entity,
              serviceData: entity.services[0],
              linksData: service,
              position: {
                x: serviceSphere.position.x,
                y: serviceSphere.position.y,
              },
            };
            // this.spheres.find((a) => a.name === entity.ref).addChild(serviceSphere);

            this.spheresServices.push(serviceSphere);
          }
          continue;
        }
        for (const service of entity.services) {
          i++;
          const serviceSphere = new Babylon.Mesh.CreateSphere(
            `${entity.ref}-${service.service_name}`,
            options3D.x10.sphere.segments,
            options3D.x10.sphere.diameter,
            this.experienceScene
          );

          const position = {
            x:
              options3D.x10.sphere._r * Math.cos((Math.PI / 6) * i) +
              entity.position.x,
            y:
              options3D.x10.sphere._r * Math.sin((Math.PI / 6) * i) +
              entity.position.y,
            z:
              options3D.x10.sphere._r * Math.tan((Math.PI / 6) * i) +
              entity.position.z,
          };
          serviceSphere.position = new Babylon.Vector3(
            position.x,
            position.y,
            position.z
          );
          this.spheresServices.push(serviceSphere);

          //sphere material

          // parse rgba color
          let sphereColor = getColorArray(entity.colors.secondary) || {
            r: 229 / 255,
            g: 61 / 255,
            b: 61 / 255,
            a: 0.6,
          };

          serviceSphere.material = sphereShader(sphereColor);
          serviceSphere.computeWorldMatrix(true);

          // sphere action manager
          serviceSphere.actionManager = new Babylon.ActionManager(
            this.experienceScene
          );
          serviceSphere.actionManager.registerAction(
            new Babylon.ExecuteCodeAction(
              Babylon.ActionManager.OnPickTrigger,
              this.servicesClickAction
            )
          );
          serviceSphere.actionManager.registerAction(
            new Babylon.ExecuteCodeAction(
              Babylon.ActionManager.OnPointerOverTrigger,
              this.servicesHoverAction
            )
          );
          serviceSphere.actionManager.registerAction(
            new Babylon.ExecuteCodeAction(
              Babylon.ActionManager.OnPointerOutTrigger,
              this.servicesHoverOutAction
            )
          );

          // service metadata
          serviceSphere.metadata = {
            entityData: entity,
            serviceData: entity.services,
            linksData: service,
            position: {
              x: serviceSphere.position.x,
              y: serviceSphere.position.y,
            },
          };

          this.spheresServices.push(serviceSphere);
        }
      }
    },
    createTubes(selectedService) {
      for (const link of selectedService.metadata.linksData.list) {
        const targetService = this.spheresServices.filter(
          (sp) => sp.id === `${entitiesNames[link.links[0]]}-${link.name}`
        )[0];
        if (typeof targetService !== "undefined") {
          const path = [
            new Babylon.Vector3(
              selectedService.position.x,
              selectedService.position.y,
              options3D.x10.sphere.sphereInitial_z
            ),
            new Babylon.Vector3(
              targetService.position.x,
              targetService.position.y,
              options3D.x10.sphere.sphereInitial_z
            ),
          ];

          let tube = Babylon.MeshBuilder.CreateTube(
            "tube",
            { path, radius: options3D.x10.tube.diameter },
            this.experienceScene
          );
          tube.metadata = {
            entity: selectedService.metadata.entityData,
            targetName: link.name,
            description: link.description,
          };

          // actions
          tube.actionManager = new Babylon.ActionManager(this.experienceScene);
          tube.actionManager.registerAction(
            new Babylon.ExecuteCodeAction(
              Babylon.ActionManager.OnPointerOverTrigger,
              this.servicesTubeHoverAction
            )
          );
          tube.actionManager.registerAction(
            new Babylon.ExecuteCodeAction(
              Babylon.ActionManager.OnPointerOutTrigger,
              this.servicesTubeHoverOutAction
            )
          );
          const tubeColor = getColorArray(
            selectedService.metadata?.entityData?.colors.secondary
          ) || {
            r: 229 / 255,
            g: 61 / 255,
            b: 61 / 255,
            a: 0.6,
          };

          //sphere color
          let material = new Babylon.StandardMaterial(this.experienceScene);
          // parse rgba color
          material.diffuseColor = new Babylon.Color3(
            tubeColor.r,
            tubeColor.g,
            tubeColor.b
          );
          material.alpha = 0.8;
          tube.material = material;

          this.tubeServices.push(tube);
        } else {
          console.log(false, `${entitiesNames[link.links[0]]}-${link.name}`);
        }
      }
    },
    loadAtome() {
      if (this.atome === null) {
        const atomeFile = atomes[this.entities[this.selectedEntity].ref];
        new Babylon.SceneLoader.ImportMesh(
          "",
          "./assets/meshs/atomes/",
          atomeFile,
          this.experienceScene,
          (meshes) => {
            const colaborators =
              this.entities[this.selectedEntity].colaborators;
            meshes[0].position.z = 0;

            const anneau = meshes.filter((mesh) =>
              mesh.name.includes("Anneau")
            )[0];
            const animatedSphere = meshes.filter((mesh) =>
              mesh.name.includes("Electron")
            )[0];
            anneau.addChild(animatedSphere);

            const [execSphere, ...otherExecSphere] = meshes.filter((mesh) =>
              mesh.name.includes("Sphere")
            );

            // Creatin Inner spheres
            const executives = collabGetExec(colaborators);
            let j = 0;
            for (const exec of executives) {
              const sphere = new Babylon.Mesh.CreateSphere(
                `exec-${exec.name}`,
                options3D.x10.sphere.segments,
                0.7,
                this.experienceScene
              );
              sphere.material = execSphere.material;

              const position = {
                x: 0.6 * Math.cos((Math.PI / executives.length) * 2 * j),
                y: 0.6 * Math.sin((Math.PI / executives.length) * 2 * j),
                z: 0.6 * Math.tan(Math.PI * j),
              };
              sphere.position = new Babylon.Vector3(
                position.x,
                position.y,
                position.z
              );

              sphere.actionManager = new Babylon.ActionManager(
                this.experienceScene
              );
              sphere.metadata = {
                entityData: this.entities[this.selectedEntity],
                serviceName: exec.service_name,
                colaborator: exec,
              };
              sphere.actionManager.registerAction(
                new Babylon.ExecuteCodeAction(
                  Babylon.ActionManager.OnPointerOverTrigger,
                  this.colaboratorHoverAction
                )
              );
              sphere.actionManager.registerAction(
                new Babylon.ExecuteCodeAction(
                  Babylon.ActionManager.OnPointerOutTrigger,
                  this.colaboratorHoverOutAction
                )
              );

              meshes[0].addChild(sphere);
              j++;
            }
            execSphere.dispose();
            let i = 0;

            // create rings
            for (const service of colaborators) {
              const managers = collabGetManager(service);
              const peoples = collabGetPeople(service);
              const colabs = [...managers, ...peoples];

              if (colabs.length === 0) continue;
              let ring = anneau.clone(`ring-${service.service_name}`);

              i++;
              // for my eyes
              let ringMaterial = new Babylon.StandardMaterial(
                this.experienceScene
              );
              ringMaterial.diffuseColor = Babylon.Color3.White();
              // ringMaterial.alpha = 0.4;
              ring.material = ringMaterial;

              ring.scaling = new Babylon.Vector3(
                0.6 + 0.01 * i + colabs.length / 50,
                0.6 + 0.01 * i + colabs.length / 50,
                0.6 + 0.01 * i + colabs.length / 50
              );
              // Creation fo colaborators sphere
              j = 0;
              const offSet = i * 2;
              let lastType = "M";
              let sphereOffSet = 0;
              for (const colab of colabs) {
                let colabSphere = ring.getChildren()[0].clone(colab.name);
                // colab shpere size
                let colabSphereSize = 1;
                if (colab.type === "P") {
                  colabSphereSize = 0.4;
                } else if (colab.type === "M") {
                  colabSphereSize = 0.8;
                }
                if (lastType !== colab.type) {
                  sphereOffSet += lastType === "M" ? 0.5 : 0.4;
                } else {
                  sphereOffSet += colabSphereSize * 0.8;
                }
                lastType = colab.type;
                colabSphere.scaling = new Babylon.Vector3(
                  colabSphereSize,
                  colabSphereSize,
                  colabSphereSize
                );

                // coab sphere position
                const position = {
                  x: 3 * Math.cos((Math.PI / 6) * (sphereOffSet + offSet)),
                  y: 0,
                  z: 3 * Math.sin((Math.PI / 6) * (sphereOffSet + offSet)),
                };
                colabSphere.position = new Babylon.Vector3(
                  position.x,
                  position.y,
                  position.z
                );

                // colabSphere Action
                colabSphere.actionManager = new Babylon.ActionManager(
                  this.experienceScene
                );
                colabSphere.metadata = {
                  entityData: this.entities[this.selectedEntity],
                  serviceName: service.service_name,
                  colaborator: colab,
                };
                colabSphere.actionManager.registerAction(
                  new Babylon.ExecuteCodeAction(
                    Babylon.ActionManager.OnPointerOverTrigger,
                    this.colaboratorHoverAction
                  )
                );
                colabSphere.actionManager.registerAction(
                  new Babylon.ExecuteCodeAction(
                    Babylon.ActionManager.OnPointerOutTrigger,
                    this.colaboratorHoverOutAction
                  )
                );

                ring.addChild(colabSphere);
                j++;
              }
              ring.getChildren()[0].dispose();

              const angle = 18;
              if (i % 2 === 1) {
                ring.rotation = new Babylon.Vector3(
                  Math.PI / 24,
                  0,
                  (Math.PI / angle) * i
                );
              } else {
                ring.rotation = new Babylon.Vector3(
                  Math.PI / 24,
                  0,
                  -(Math.PI / angle) * i
                );
              }
              // ring action
              ring.actionManager = new Babylon.ActionManager(
                this.experienceScene
              );
              ring.metadata = {
                entityData: this.entities[this.selectedEntity],
                serviceName: service.service_name,
              };
              ring.actionManager.registerAction(
                new Babylon.ExecuteCodeAction(
                  Babylon.ActionManager.OnPointerOverTrigger,
                  this.ringHoverAction
                )
              );
              ring.actionManager.registerAction(
                new Babylon.ExecuteCodeAction(
                  Babylon.ActionManager.OnPointerOutTrigger,
                  this.ringHoverOutAction
                )
              );
              var axis = new Babylon.Vector3(0, 2, 0);
              var deltaTheta = Math.PI / 6000;
              this.experienceScene.registerBeforeRender(function () {
                ring.rotate(axis, deltaTheta, Babylon.Space.LOCAL);
              });
              meshes.push(ring);
            }
            // execSphere.dispose()
            for (const toDelete of otherExecSphere) {
              toDelete.dispose();
            }
            animatedSphere.dispose();
            anneau.dispose(); // we always need to destroy temmplate ring
            // mesh ortation handler
            meshes[0].rotation = new Babylon.Vector3(
              typeof options3D.x100.atome.rotation.x === "number"
                ? options3D.x100.atome.rotation.x
                : 0,
              typeof options3D.x100.atome.rotation.y === "number"
                ? options3D.x100.atome.rotation.y
                : 0,
              typeof options3D.x100.atome.rotation.z === "number"
                ? options3D.x100.atome.rotation.z
                : 0
            );
            this.atome = meshes[0];
          }
        );
      }
    },
    disposeAtome() {
      if (this.atome !== null) {
        this.atome.dispose();
        this.atome = null;
      }
    },
    disposeEntities() {
      for (const entity of this.spheres) {
        entity.dispose();
      }
      this.spheres = [];
    },
    disposeTubes() {
      if (this.tubeServices.length === 0) return;
      for (const tube of this.tubeServices) {
        tube.dispose();
      }
      this.tubeServices = [];
    },
    /**
     * Actions
     */
    // entity
    sphereClickAction(data) {
      if (this.currentZoom !== 5) return;
      this.entityClick(data.source.id);
    },
    sphereHoverAction(data) {
      if (this.currentZoom !== 5) return;
      this.popup.left = data.pointerX;
      this.popup.top = data.pointerY;
      this.popup.show = true;
      this.popup.type = "entity";
      this.popup.primaryColor = data.source.metadata.colors.primary;
      this.popup.logos = data.source.metadata.entity_logo;
    },
    sphereHoverOutAction() {
      if (this.currentZoom !== 5) return;
      this.popup.show = false;
    },
    //services
    servicesClickAction(data) {
      if (
        data.source.metadata.entityData.ref === "gta-supports" ||
        data.source.metadata.entityData.ref ===
          this.entities[this.selectedEntity].ref
      ) {
        if (this.currentZoom !== 10) return;
        this.setSelectedService({
          entity: data.source.metadata.entityData,
          service: data.source.metadata.linksData,
        });
        if (this.showService) {
          // destroy old tubes
          for (let i = 0; i < this.tubeServices.length; i++) {
            this.tubeServices[i].dispose();
          }
          this.tubeServices = [];
          this.showService = false;
          return;
        }
        // destroy old tubes
        for (let i = 0; i < this.tubeServices.length; i++) {
          this.tubeServices[i].dispose();
        }
        this.tubeServices = [];
        if (data.source.metadata.entityData.ref === "gta-supports") return;
        this.createTubes(data.source);
        this.showService = true;
      }
    },
    servicesHoverAction(data) {
      if (this.currentZoom !== 10) return;
      this.popup.left = data.pointerX;
      this.popup.top = data.pointerY;
      this.popup.show = true;
      this.popup.type = "service-name";
      this.popup.primaryColor = data.source.metadata.entityData.colors.primary;
      this.popup.logos = data.source.metadata.entityData.entity_logo;
      this.popup.service.name =
        data.source.metadata.linksData.service_name ||
        data.source.metadata.linksData.name;
    },
    servicesHoverOutAction(data) {
      if (this.currentZoom !== 10) return;
      this.popup.show = false;
    },
    servicesTubeHoverAction(data) {
      if (this.currentZoom !== 10) return;
      this.popup.left = data.pointerX;
      this.popup.top = data.pointerY;
      this.popup.show = true;
      this.popup.type = "service-link";
      this.popup.primaryColor = data.source.metadata.entity.colors.primary;
      this.popup.logos = data.source.metadata.entity.entity_logo;
      this.popup.service.name = data.source.metadata.targetName;
      this.popup.service.linkDescription = data.source.metadata.description;
      data.source.material.alpha = 1;
    },
    servicesTubeHoverOutAction(data) {
      if (this.currentZoom !== 10) return;
      data.source.material.alpha = 0.8;
      this.popup.show = false;
    },
    // colaborators
    ringHoverAction(data) {
      if (this.currentZoom !== 100) return;
      this.popup.left = data.pointerX;
      this.popup.top = data.pointerY;
      this.popup.show = true;
      this.popup.type = "service-name";
      this.popup.primaryColor = data.source.metadata.entityData.colors.primary;
      this.popup.logos = data.source.metadata.entityData.entity_logo;
      this.popup.service.name = data.source.metadata.serviceName;
    },
    ringHoverOutAction(data) {
      if (this.currentZoom !== 100) return;
      this.popup.show = false;
    },
    colaboratorHoverAction(data) {
      if (this.currentZoom !== 100) return;
      this.popup.left = data.pointerX;
      this.popup.top = data.pointerY;
      this.popup.show = true;
      this.popup.type = "colaborator";
      this.popup.primaryColor = data.source.metadata.entityData.colors.primary;
      this.popup.logos = data.source.metadata.entityData.entity_logo;
      this.popup.colaborator = {
        service: data.source.metadata.serviceName,
        name: data.source.metadata.colaborator.name,
        position: data.source.metadata.colaborator.position_name,
        picture: data.source.metadata.colaborator.profil_picture,
      };
    },
    colaboratorHoverOutAction(data) {
      if (this.currentZoom !== 100) return;
      this.popup.show = false;
    },

    /**
     * Animation
     */
    animateEntity() {
      for (let i = 0; i < this.spheres.length; i++) {
        const x =
          this.spheres[i].metadata.position.x +
          Math.random() / options3D.x5.sphere._s;
        const y =
          this.spheres[i].metadata.position.y +
          Math.random() / options3D.x5.sphere._s;

        this.spheres[i].position = new Babylon.Vector3(
          x,
          y,
          this.spheres[i].position.z
        );
      }
    },
    animateServices(way) {
      for (let i = 0; i < this.spheresServices.length; i++) {
        if (
          way > 0 &&
          this.spheresServices[i].position.z + options3D.x10.sphere._s <=
            options3D.x10.sphere.sphereInitial_z
        ) {
          this.spheresServices[i].position.z += options3D.x10.sphere._s;
        } else if (
          way > 0 &&
          this.spheresServices[i].position.z + options3D.x10.sphere._s >
            options3D.x10.sphere.sphereInitial_z
        ) {
          this.spheresServices[i].position.z =
            options3D.x10.sphere.sphereInitial_z;
        } else if (
          way < 0 &&
          this.spheresServices[i].position.z - options3D.x10.sphere._s >=
            options3D.x10.sphere._z
        ) {
          this.spheresServices[i].position.z -= options3D.x10.sphere._s;
        } else if (
          way < 0 &&
          this.spheresServices[i].position.z - options3D.x10.sphere._s <
            options3D.x10.sphere._z
        ) {
          this.spheresServices[i].position.z = options3D.x10.sphere._z;
        }

        if (flags.mouvement.services) {
          const x =
            this.spheresServices[i].metadata.position.x +
            Math.random() / options3D.x10.sphere._rand;
          const y =
            this.spheresServices[i].metadata.position.y +
            Math.random() / options3D.x10.sphere._rand;

          this.spheresServices[i].position = new Babylon.Vector3(
            x,
            y,
            this.spheresServices[i].position.z
          );
        }
      }
    },
    animateAtome(way) {
      if (
        way > 0 &&
        this.experienceScene.cameras[0].position.z - options3D.x100.camera._s >
          options3D.x100.camera._z
      ) {
        this.experienceScene.cameras[0].position.z -= options3D.x100.camera._s;
      } else if (
        way > 0 &&
        this.experienceScene.cameras[0].position.z - options3D.x100.camera._s <
          options3D.x100.camera._z
      ) {
        this.experienceScene.cameras[0].position.z = options3D.x100.camera._z;
      } else if (
        way < 0 &&
        this.experienceScene.cameras[0].position.z + options3D.x100.camera._s <
          options3D.x5.experienceCamera.z
      ) {
        this.experienceScene.cameras[0].position.z += options3D.x100.camera._s;
      } else if (
        way < 0 &&
        this.experienceScene.cameras[0].position.z + options3D.x100.camera._s >
          options3D.x5.experienceCamera.z
      ) {
        this.experienceScene.cameras[0].position.z =
          options3D.x5.experienceCamera.z;
      }
    },
    // static animation
    staticEntity(goToZ, visible = true) {
      for (const entity of this.spheres) {
        entity.position = new Babylon.Vector3(
          entity.position.x,
          entity.position.y,
          goToZ
        );

        if (!visible) {
          entity.material.alpha = 0;
        } else {
          entity.material.alpha = 1;
        }
      }
    },
    staticServices(goToZ, visible = true) {
      for (const service of this.spheresServices) {
        service.position = new Babylon.Vector3(
          service.position.x,
          service.position.y,
          goToZ
        );
        if (!visible) {
          service.material.alpha = 0;
        } else {
          service.material.alpha = 1;
        }
      }
    },
    staticCollaborators(goToZ, visible = true) {
      if (this.atome !== null) {
        this.atome.position = new Babylon.Vector3(
          this.atome.position.x,
          this.atome.position.y,
          goToZ
        );
      }
    },

    /**
     *      UI methods
     */
    resetPopup() {
      this.popup = {
        left: null,
        top: null,
        show: false,
        // popup type
        /**
         *   entity
         *   service-name
         *   service-link
         *   colaborator
         */
        type: null,
        // data
        logos: {}, // getting all the logos
        primaryColor: null,
        service: {
          name: null,
          linkDescription: null,
        },
        colaborator: {
          service: null,
          name: null,
          position: null,
          picture: null,
        },
      };
    },
    /**
     *      Blur effect
     */
    blurScene(scene) {
      if (this.postProcessInterval !== undefined)
        clearInterval(this.postProcessInterval);
      let pipeline = new Babylon.DefaultRenderingPipeline(
        "pipeline",
        false,
        scene,
        scene.cameras
      );
      pipeline.imageProcessingEnabled = true;
      pipeline.imageProcessing.vignetteEnabled = true;
      pipeline.imageProcessing.vignetteWeight = 5;

      let kernel = 32.0;
      let postProcess0 = new Babylon.BlurPostProcess(
        "Horizontal blur",
        new Babylon.Vector2(1.0, 0),
        kernel,
        1.0,
        scene.activeCamera
      );
      let postProcess1 = new Babylon.BlurPostProcess(
        "Vertical blur",
        new Babylon.Vector2(0, 1.0),
        kernel,
        1.0,
        scene.activeCamera
      );

      this.postProcessInterval = setInterval(() => {
        if (postProcess0.kernel >= 0) {
          postProcess0.kernel -= 0.2;
          postProcess1.kernel -= 0.2;
        }
      }, 150);
      setTimeout(() => {
        scene.activeCamera.detachPostProcess(postProcess0);
        scene.activeCamera.detachPostProcess(postProcess1);
        clearInterval(this.postProcessInterval);
      }, 800);
    },
  },
};
function getColorArray(rgba) {
  let split = rgba.split(",");
  split = split.map((str) => {
    const regex = /[0-9]/g;
    const result = str.match(regex).join("");
    return parseInt(result);
  });

  for (const key of split) if (typeof key === "undefined") return;
  return {
    r: split[0] / 255,
    g: split[1] / 255,
    b: split[2] / 255,
    a: split[3] / 10,
  };
}
/**
 * Colaborators functions
 */

// get regular employees
function collabGetPeople(service) {
  let peoples = [];

  for (const colab of service.service_colaborators) {
    if (colab.type === "P") {
      colab.service_name = service.servcie_name;
      peoples.push(colab);
    }
  }
  // black magic in here, just to prevent the returned value to be an observable
  return JSON.parse(JSON.stringify(peoples));
}
// get manager employees
function collabGetManager(service) {
  let managers = [];

  for (const colab of service.service_colaborators) {
    if (colab.type === "M") {
      colab.service_name = service.servcie_name;
      managers.push(colab);
    }
  }
  // black magic in here, just to prevent the returned value to be an observable
  return JSON.parse(JSON.stringify(managers));
}
// get executive employees
function collabGetExec(colaborators) {
  let exec = [];
  for (const service of colaborators) {
    for (const colab of service.service_colaborators) {
      if (colab.type === "G") {
        colab.service_name = service.service_name;
        exec.push(colab);
      }
    }
  }
  // black magic in here, just to prevent the returned value to be an observable
  return JSON.parse(JSON.stringify(exec));
}

function randomisePoistion(max, min) {
  const isNegative = Math.random() > 0.5;

  let random = null;

  do {
    random = Math.random();
  } while (random === null || random >= max || random <= min);

  return isNegative ? -random : random;
}

function materialCheker(mesh, color, reset) {
  if (reset) {
    mesh.material = sphereShader(getColorArray(color));
  } else {
    mesh.material = sphereShader(getColorArray(color), 0.3);
  }
}
</script>
